import * as React from "react";
import { SVGProps, memo } from "react";

const SvgInsuranceCard = (props: SVGProps<SVGSVGElement>) => (
  <svg width={38} height={24} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M34.54 23.991 3.127 24C1.68 24 .508 22.808.508 21.334L.5 2.674C.5 1.201 1.671.01 3.118.01L34.54 0c1.447 0 2.618 1.192 2.618 2.666l.009 18.66c-.017 1.465-1.18 2.665-2.627 2.665Z"
      fill="#CDE8DA"
    />

    <mask
      id="InsuranceCard_svg__a"
      style={{
        maskType: "alpha",
      }}
      maskUnits="userSpaceOnUse"
      x={0}
      y={0}
      width={38}
      height={24}
    >
      <path
        d="M34.54 23.991 3.127 24C1.68 24 .508 22.808.508 21.334L.5 2.674C.5 1.201 1.671.01 3.118.01L34.54 0c1.447 0 2.618 1.192 2.618 2.666l.009 18.66c-.017 1.465-1.18 2.665-2.627 2.665Z"
        fill="#37A16B"
      />
    </mask>

    <g mask="url(#InsuranceCard_svg__a)">
      <path opacity={0.5} d="M.5 0v5.433h36.667V0H.5Z" fill="#37A16B" />

      <rect
        x={2.918}
        y={1.631}
        width={10.492}
        height={1.779}
        rx={0.889}
        fill="#000"
        fillOpacity={0.5}
      />

      <rect
        x={4.476}
        y={8.561}
        width={15.363}
        height={1.681}
        rx={0.841}
        fill="#000"
        fillOpacity={0.3}
      />

      <rect
        x={4.476}
        y={12.974}
        width={15.363}
        height={1.681}
        rx={0.841}
        fill="#000"
        fillOpacity={0.3}
      />

      <rect
        x={4.599}
        y={17.386}
        width={11.196}
        height={1.681}
        rx={0.841}
        fill="#000"
        fillOpacity={0.3}
      />

      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M34.391 17.28h.222v2.252h-.74v-.673h-.326v1l1.066-.001v1.207h-.221v-.954H33.15v.326h.916v.628h-2.015v-.775h.737l.031-1.305h-1.776v.832h-.215V17.28h.46v1.384h1.296v-.718h.654v.692h.326V17.62h-1.306v.718h-.645v-1.058h2.453v1.221h.325v-1.221Zm-2.666 2.684v1.101h-.897v-.923h.54v-.832h1.118l-.016.654h-.745Zm-1.222 1.427v-4.436h4.435v4.436h-4.435Z"
        fill="#EB5757"
      />
    </g>
  </svg>
);

const Memo = memo(SvgInsuranceCard);

export default Memo;
